import React from 'react';

const RunbookSelectTriggerSVG = (props) => (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M10.724 20.0144C15.9925 20.0144 20.2634 15.7434 20.2634 10.475C20.2634 5.20649 15.9925 0.935547 10.724 0.935547C5.45551 0.935547 1.18457 5.20649 1.18457 10.475" stroke="currentColor"/>
        <path d="M10.7243 15.9926C13.7707 15.9926 16.2402 13.5231 16.2402 10.4768C16.2402 7.43047 13.7707 4.96094 10.7243 4.96094C7.67803 4.96094 5.2085 7.43047 5.2085 10.4768" stroke="currentColor" strokeWidth="2"/>
        <path d="M5.59727 15.6445L2.22217 19.0194" stroke="currentColor" strokeWidth="2"/>
        <path d="M9.94374 11.2982L7.49058 18.6353L2.60669 13.7514L9.94374 11.2982Z" fill="currentColor"/>
</svg>
);

export default RunbookSelectTriggerSVG;
